/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

// Recurso singular (não tem :id) — endpoint novo, isolado:
// GET/PATCH /api/v1/accounts/:account_id/sidebar_menu_visibility
class SidebarMenuVisibilityAPI extends ApiClient {
  constructor() {
    super('sidebar_menu_visibility', { accountScoped: true });
  }

  update(config) {
    return axios.patch(this.url, { config });
  }
}

export default new SidebarMenuVisibilityAPI();
